import { type ElementType } from "react";
import { USER_ROLES } from "../app/app.constants";
import Login from "../pages/auth/login/login";
import Otp from "../pages/auth/login/otp";
import Registration from "../pages/auth/registration/registration";
import RegistrationOtp from "../pages/auth/registration/registration-otp";
import ComingSoon from "../pages/ComingSoon";
import NotFound from "../pages/NotFound";
import CourseModule from "../pages/user/courseModule";
import UserCourses from "../pages/user/courses";
import UserCourseDetails from "../pages/user/coursesDetails";
import UserDashboard from "../pages/user/dashboard";
import UserProfile from "../pages/user/profile";
import UserProfileUpdate from "../pages/user/profileUpdate";
import UserReviewList from "../pages/user/reviews";
import UserSetting from "../pages/user/setting";
import UserDiscount from "../pages/user/userDiscount/UserDiscount";
import UserWishlist from "../pages/user/wishlist";
import AboutUs from "../pages/web/about-us/AboutUs";
import AllCourses from "../pages/web/allCourses";
import PublicCertificate from "../pages/web/certificates/PublicCertificate";
import CancelPayment from "../pages/web/checkout/CancelPayment";
import Checkout from "../pages/web/checkout/checkout";
import FailedPayment from "../pages/web/checkout/FailedPayment";
import SuccessPayment from "../pages/web/checkout/SuccessPayment";
import WebCourseDetails from "../pages/web/courseDetails";
import Courses from "../pages/web/courses";
import Home from "../pages/web/home";
import Faq from "../pages/web/policy/Faq";
import PrivacyPolicy from "../pages/web/policy/PrivacyPolicy";
import RefundPolicy from "../pages/web/policy/RefundPolicy";
import Story from "../pages/web/story";
import UserManual from "../pages/web/UserManual/UserManual";
import type { AppRoute } from "../types/global.types";

// App routes
export const APP_ROUTES: AppRoute[] = [
  // ------ Routes for Resident & Staff (ADMIN) ------
  {
    path: "/user",
    roles: [USER_ROLES.USER],
    children: [
      {
        element: UserDashboard,
        roles: [USER_ROLES.USER],
        path: "/user/dashboard",
      },
      {
        element: UserCourseDetails,
        roles: [USER_ROLES.USER],
        path: "/user/dashboard/courses/:id",
      },
      {
        element: UserProfile,
        roles: [USER_ROLES.USER],
        path: "/user/profile",
      },
      {
        element: UserProfileUpdate,
        roles: [USER_ROLES.USER],
        path: "/user/profile/update",
      },
      {
        element: UserDiscount,
        roles: [USER_ROLES.USER],
        path: "/user/discount",
      },
      {
        element: UserCourses,
        roles: [USER_ROLES.USER],
        path: "/user/courses",
      },
      {
        element: UserCourseDetails,
        roles: [USER_ROLES.USER],
        path: "/user/courses/:id",
      },
      {
        element: CourseModule,
        roles: [USER_ROLES.USER],
        path: "/user/courses/:id/module",
      },
      {
        element: CourseModule,
        roles: [USER_ROLES.USER],
        path: "/user/courses/:id/module/:moduleId",
      },
      {
        element: UserWishlist,
        roles: [USER_ROLES.USER],
        path: "/user/wish-list",
      },
      {
        element: UserReviewList,
        roles: [USER_ROLES.USER],
        path: "/user/reviews",
      },
      {
        element: UserSetting,
        roles: [USER_ROLES.USER],
        path: "/user/setting",
      },
    ],
  },
];

// Public routers
export const PUBLIC_ROUTES: {
  path: string;
  element: ElementType;
  name?: string;
}[] = [
  {
    path: "*",
    element: NotFound,
  },
  {
    path: "/login",
    element: Login,
  },
  {
    path: "/otp",
    element: Otp,
  },
  {
    path: "/registration",
    element: Registration,
  },
  {
    path: "/registration-otp",
    element: RegistrationOtp,
  },
  {
    path: "/",
    element: Home,
  },
  {
    path: "/courses",
    element: Courses,
  },
  {
    path: "/courses/all",
    element: AllCourses,
  },
  {
    path: "/courses/:id",
    element: WebCourseDetails,
  },
  {
    path: "/jobs",
    element: ComingSoon,
  },
  // {
  //   path: "/jobs",
  //   element: Jobs,
  // },
  // {
  //   path: "/jobs/:id",
  //   element: WebJobDetails,
  // },
  {
    path: "/checkout",
    element: Checkout,
  },
  {
    path: "/payment/success",
    element: SuccessPayment,
  },
  {
    path: "/payment/failed",
    element: FailedPayment,
  },
  {
    path: "/payment/cancel",
    element: CancelPayment,
  },
  {
    path: "/success-story",
    element: Story,
  },
  {
    path: "/privacy-policy",
    element: PrivacyPolicy,
  },
  {
    path: "/refund-policy",
    element: RefundPolicy,
  },
  {
    path: "/faq",
    element: Faq,
  },
  {
    path: "/about-us",
    element: AboutUs,
  },
  {
    path: "/verify-certificate/:certificateNo",
    element: PublicCertificate,
  },
  {
    path: "/user-manual",
    element: UserManual,
  },
];
